export interface SingaporeSubRegion {
    name: string;
    lat: GLfloat;
    lng: GLfloat;
    radius: Number;
}
export const SINGAPORE_SUB_REGION: { [key: number]: SingaporeSubRegion } = {

    // Central/South
    3: { name: "Queenstown, Tiong Bahru", lat: 1.2963, lng: 103.7855, radius: 2000 },
    8: { name: "Novena, Thomson", lat: 1.3203, lng: 103.8437, radius: 2000 },
    9: { name: "Orchard, River Valley", lat: 1.2988, lng: 103.8318, radius: 2000 },
    10: { name: "Sentosa, Harbourfront", lat: 1.3125, lng: 103.8378, radius: 2000 },
    24: { name: "East Coast, Marine Parade", lat: 1.3030, lng: 103.9120, radius: 2000 }, // Fixed
    52: { name: "Bugis, Rochor", lat: 1.2996, lng: 103.8550, radius: 2000 },
    58: { name: "CBD", lat: 1.2806, lng: 103.8515, radius: 2000 },

    // East
    19: { name: "Bedok, Kembangan", lat: 1.3230, lng: 103.9200, radius: 2000 }, // Adjusted
    21: { name: "Tampines, Pasir Ris", lat: 1.3541, lng: 103.9455, radius: 2000 },
    22: { name: "Changi, Loyang", lat: 1.3770, lng: 103.9630, radius: 2000 }, // Fixed
    77: { name: "Changi Airport", lat: 1.3644, lng: 103.9915, radius: 2000 },
    78: { name: "Katong, Joo Chiat", lat: 1.3030, lng: 103.8998, radius: 2000 },

    // North/Northeast
    13: { name: "Yishun", lat: 1.4300, lng: 103.8350, radius: 2000 },
    35: { name: "Hougang", lat: 1.3710, lng: 103.8928, radius: 2000 },
    38: { name: "Upper Thomson", lat: 1.3545, lng: 103.8300, radius: 2000 }, // Fixed
    63: { name: "Seletar", lat: 1.4040, lng: 103.8690, radius: 2000 }, // Fixed
    64: { name: "Punggol", lat: 1.3984, lng: 103.9075, radius: 2000 },
    65: { name: "Sengkang", lat: 1.3915, lng: 103.8959, radius: 2000 },

    // West
    28: { name: "Bukit Panjang, Hillview", lat: 1.3596, lng: 103.7492, radius: 2000 },
    29: { name: "Jurong West", lat: 1.3404, lng: 103.7057, radius: 2000 },
    31: { name: "Pasir Panjang", lat: 1.3055, lng: 103.7950, radius: 2000 }, // Fixed
    66: { name: "Clementi", lat: 1.3153, lng: 103.7644, radius: 2000 }, // Fixed
    67: { name: "Bukit Batok", lat: 1.3490, lng: 103.7496, radius: 2000 }, // Fixed
    68: { name: "Jurong East", lat: 1.3329, lng: 103.7416, radius: 2000 },
    79: { name: "Tuas", lat: 1.3210, lng: 103.6365, radius: 2000 },

    // Central-North
    18: { name: "Toa Payoh, Balestier", lat: 1.3285, lng: 103.8532, radius: 2000 }, // Fixed
    50: { name: "Little India, Farrer Park", lat: 1.3068, lng: 103.8513, radius: 2000 },
    53: { name: "Bukit Timah, Tanglin", lat: 1.3253, lng: 103.8161, radius: 2000 },
    54: { name: "Braddell, Macpherson", lat: 1.3342, lng: 103.8863, radius: 2000 },
    55: { name: "Geylang, Eunos", lat: 1.3160, lng: 103.8930, radius: 2000 }, // Adjusted
    56: { name: "Upper Bukit Timah", lat: 1.3601, lng: 103.7765, radius: 2000 },
    59: { name: "Bishan, AMK", lat: 1.3506, lng: 103.8489, radius: 2000 }
}